import { Box, Chip, Divider, IconButton, Typography } from '@mui/material'
import React, { useMemo, useState } from 'react'
import ListPinItem from './ListPinItem'
import { transformDetailWithPhone } from '../utils/transformDetail'
import ImageViewerModal from './ImageViewerModal'

export default function OrderInfoCard({ orderData, isExpanded = false }) {
	const [openImageModal, setOpenImageModal] = useState(false)
	const [selectedImage, setSelectedImage] = useState(null)

	const line_items = useMemo(() => {
		if (typeof orderData?.line_items === 'string') {
			try {
				return JSON.parse(orderData?.line_items)
			} catch (error) {
				return []
			}
		}
		return orderData?.line_items ?? []
	}, [orderData])

	const tags = useMemo(() => {
		if (typeof orderData?.tag === 'string') {
			return JSON.parse(orderData?.tag)
		}
		return orderData?.tag ?? []
	}, [orderData])

	const handleImageClick = (url) => {
		setSelectedImage(url)
		setOpenImageModal(true)
	}

	const handleCloseModal = () => {
		setOpenImageModal(false)
		setSelectedImage(null)
	}

	return (
		<Box sx={{ mt: 2 }}>
			{/* Order Total */}
			<Typography sx={styles.total}>
				{orderData?.quantity || 0}Kg / {(orderData?.totalPrice || 0).toLocaleString()}đ
			</Typography>

			{/* Order Items Grid */}
			<ListPinItem line_items={line_items} />

			<Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
				{orderData.detail && (
					<>
						<Divider sx={{ bgcolor: 'primary.main', opacity: 0.5 }} />
						<Box sx={{ textAlign: 'end' }}>
							<Typography
								variant='body1'
								dangerouslySetInnerHTML={{ __html: transformDetailWithPhone(orderData.detail) }}
							/>
						</Box>
					</>
				)}

				{orderData.customerNote && (
					<>
						<Divider sx={{ bgcolor: 'primary.main', opacity: 0.5 }} />
						{orderData.shippingTime && (
							<Box sx={{ textAlign: 'end' }}>
								<Typography variant='body1'>{orderData.shippingTime}</Typography>
							</Box>
						)}
						<Box sx={{ textAlign: 'end' }}>
							<Typography
								variant='body1'
								sx={{ whiteSpace: 'pre-line' }}
								dangerouslySetInnerHTML={{ __html: transformDetailWithPhone(orderData.customerNote) }}
							/>
						</Box>
					</>
				)}

				<Divider sx={{ bgcolor: 'primary.main', opacity: 0.5 }} />

				{orderData.note && (
					<Box sx={{ textAlign: 'end' }}>
						<Typography variant='body1'>{orderData.note}</Typography>
					</Box>
				)}

				<Box sx={{ textAlign: 'end' }}>
					<Typography variant='body1'>
						Thanh toán:{' '}
						{orderData.payment === 'transfer' ? 'Chuyển khoản' : orderData.payment === 'cash' ? 'Tiền mặt' : 'Nhanh'}
					</Typography>
				</Box>

				{orderData.shippingTotal != null && (
					<Box sx={{ textAlign: 'end' }}>
						<Typography variant='body1'>
							Phí ship: {new Intl.NumberFormat().format(orderData.shippingTotal)}đ
						</Typography>
					</Box>
				)}

				{orderData.photoAttach && orderData.photoAttach.length > 0 && (
					<Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
						{orderData.photoAttach.map((url) => (
							<IconButton key={url} onClick={() => handleImageClick(url)}>
								<img src={url} alt='Hóa đơn' style={{ width: '50px', height: '50px' }} />
							</IconButton>
						))}
					</Box>
				)}

				{(orderData.code || orderData.source) && isExpanded && (
					<>
						<Divider sx={{ bgcolor: 'primary.main', opacity: 0.5 }} />
						<Box sx={{ textAlign: 'end' }}>
							<Typography variant='body1' sx={{ whiteSpace: 'pre-line' }}>
								{`Code: ${orderData.code ?? '#'}\nNền tảng: ${orderData.source?.toUpperCase()}`}
							</Typography>
						</Box>
					</>
				)}

				{tags && tags.length > 0 && (
					<Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
						{tags.map((tag, index) => (
							<Chip
								key={index}
								label={tag.name}
								sx={{ backgroundColor: tag.color, color: 'white', fontWeight: 500, borderRadius: '20px' }}
							/>
						))}
					</Box>
				)}
			</Box>

			<ImageViewerModal open={openImageModal} onClose={handleCloseModal} src={selectedImage} />
		</Box>
	)
}

const styles = {
	total: {
		color: '#4CAF50',
		fontSize: '24px',
		fontWeight: 500,
		textAlign: 'center',
		mb: 2,
	},
}

